











import { defineComponent } from '@vue/composition-api'
import { useCreateLeadForm } from '@/composables/useCreateLeadForm'

export default defineComponent({
    name: 'CreateLeadHeader',
    setup() {
        const { close } = useCreateLeadForm()

        return {
            close,
        }
    },
})
